import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const BrandDropdown = ({ brands, value, onChange, placeholder = "Select a brand" }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const selectedBrand = brands?.find((b) => b._id === value);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* Selected Value */}
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full border border-orange-300 rounded-md p-2 mt-1 flex justify-between items-center text-left focus:border-orange-500 focus:ring-orange-500"
      >
        <span className={selectedBrand ? "text-gray-900" : "text-gray-400"}>
          {selectedBrand ? selectedBrand.brandName : placeholder}
        </span>
        <span className="text-gray-500">▾</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 w-full bg-white border border-gray-200 rounded-md shadow-md mt-1 max-h-60 overflow-auto">
          {/* Brands List */}
          {brands?.length > 0 ? (
            brands.map((brand) => (
              <div
                key={brand._id}
                onClick={() => {
                  onChange(brand);
                  setOpen(false);
                }}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                  brand._id === value ? "bg-gray-100 font-medium" : ""
                }`}
              >
                {brand.brandName}
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-400">
              No brands available
            </div>
          )}

          {/* Divider */}
          <div className="border-t my-1"></div>

          {/* New Brand Action */}
          <div
            onClick={() => navigate("/company/dashboard/brands/create")}
            className="px-3 py-2 cursor-pointer text-orange-500 font-medium hover:bg-orange-50"
          >
            + New Brand
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandDropdown;
